import ApplicationView from './common/ApplicationView';

/**
 * @class LoginView
 * @description View for the login form. Use show()/hide() to display or hide the login screen.
 */
class LoginView extends ApplicationView
{
  constructor(app)
  {
    super('login', $('.login'));
    this.app = app;
    this.password_input = document.querySelector('.login__form-input--password');
    this.username_input = document.querySelector('.login__form-input--username');
    this.password_icon_closed = document.querySelector('.login__input-icon--closed');
    this.password_icon_open = document.querySelector('.login__input-icon--open');

    this.username_input.addEventListener('input', this.on_input_change.bind(this));
    this.password_input.addEventListener('input', this.on_input_change.bind(this));
  }

  start()
  {
    super.start();
  }

  toggle_password_visibility()
  {
    this.password_input.type = this.password_input.type === 'password' ? 'text' : 'password';
    this.password_icon_closed.classList.toggle('hidden');
    this.password_icon_open.classList.toggle('hidden');
  }

  on_input_change()
  {
    this.username_input.classList.remove('login__form-input--error');
    this.password_input.classList.remove('login__form-input--error');
  }

  on_submit()
  {
    this.username_input.classList.remove('login__form-input--error');
    this.password_input.classList.remove('login__form-input--error');
    if (this.username_input.value === '' || this.password_input.value === '')
    {
      if (this.username_input.value === '')
      {
        this.username_input.classList.add('login__form-input--error');
      }
      if (this.password_input.value === '')
      {
        this.password_input.classList.add('login__form-input--error');
      }
      return;
    }
    console.warn('TODO: Implement login with username and password', this.username_input.value, this.password_input.value);
    this.hide();
  }
}

export { LoginView };
